import { apiSlice } from 'state/slices/apiSlice';

const MAILS_URL = '/mails';

export const mailApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMailTemplates: builder.query({
      query: () => MAILS_URL + '/templates',
      providesTags: ['MailTemplates'],
    }),
    deleteMailTemplate: builder.mutation({
      query: (id) => ({
        url: MAILS_URL + '/templates/delete',
        method: 'DELETE',
        body: { id },
      }),
      invalidatesTags: ['MailTemplates'],
    }),
    saveMailTemplate: builder.mutation({
      query: (data) => ({
        url: MAILS_URL + '/save',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Mails'],
    }),
    updateMailTemplate: builder.mutation({
      query: (data) => ({
        url: MAILS_URL + '/templates/update',
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['MailTemplates'],
    })
  }),
});

export const {
  useGetMailTemplatesQuery,
  useDeleteMailTemplateMutation,
  useSaveMailTemplateMutation,
  useUpdateMailTemplateMutation
} = mailApiSlice;
